import React, { useEffect, useState } from "react";

// react router dom
import { useLocation, useNavigate } from "react-router-dom";

// components
import Siderbar from "../components/Sidebar/Sidebar";
import Header from "../components/Header/Header";
import DarkMode from "../components/DarkMode/DarkMode";

// Custom Hooks
import { useDarkMode } from "../hooks/useDarkmode";

// styled components and dark and light pallet color
import { darkTheme, lightTheme } from "../theme/Theme";
import { ThemeProvider } from "styled-components";
import { Container, Main, MainContent } from "./mainLayoutStyle";
import Cookies from "js-cookie";

const MainLayout = ({ children }) => {
  const [isShowSidebar, setIsShowSidebar] = useState(true);
  const [fixed, setFixed] = useState(true);
  const navigate = useNavigate();
  const [theme, themeToggler, mountedComponent] = useDarkMode();

  const location = useLocation();
  const locationParams = location.pathname.split("/");

  const themeMode = theme === "light" ? lightTheme : darkTheme;

  if (!mountedComponent) return <div />;

  return (
    <ThemeProvider theme={themeMode}>
      <Container>
        {location.pathname === "/login" ? null : location.pathname ===
          `/factor/${locationParams[2]}` ? null : (
          <Siderbar
            isShowSidebar={isShowSidebar}
            setIsShowSidebar={setIsShowSidebar}
            fixed={fixed}
            setFixed={setFixed}
          />
        )}
        <Main isShowSidebar={isShowSidebar}>
          {location.pathname === "/login" ? null : location.pathname ===
            `/factor/${locationParams[2]}` ? null : (
            <Header
              setFixed={setFixed}
              isShowSidebar={isShowSidebar}
              setIsShowSidebar={setIsShowSidebar}
            />
          )}
          <MainContent>{children}</MainContent>
        </Main>
        {location.pathname === `/factor/${locationParams[2]}` ? null : (
          <DarkMode theme={theme} themeToggler={themeToggler} />
        )}
      </Container>
    </ThemeProvider>
  );
};

export default MainLayout;
